import { AuthLayout } from "../commons/authLayout/authLayout";
import { LoginForm } from "../features/loginForm";

export const LoginPage = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};
